import { render, staticRenderFns } from "./NsPassword.vue?vue&type=template&id=f1ca67fc&scoped=true&"
import script from "./NsPassword.vue?vue&type=script&lang=js&"
export * from "./NsPassword.vue?vue&type=script&lang=js&"
import style0 from "./NsPassword.vue?vue&type=style&index=0&id=f1ca67fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1ca67fc",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VFlex,VLayout,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1ca67fc')) {
      api.createRecord('f1ca67fc', component.options)
    } else {
      api.reload('f1ca67fc', component.options)
    }
    module.hot.accept("./NsPassword.vue?vue&type=template&id=f1ca67fc&scoped=true&", function () {
      api.rerender('f1ca67fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/design-components/src/components/NsPassword.vue"
export default component.exports